module.exports = __webpack_public_path__ + "static/media/info-icon.5c7b1f20.svg";